<div class="step-navigation-container">
  <!-- Step Indicators -->
  <div class="step-indicators" *ngIf="steps.length > 0">
    <div class="step-indicator-row">
      <ng-container *ngFor="let step of steps; let i = index">
        <div
          class="step-indicator"
          [ngClass]="{
            active: isStepActive(step),
            completed: isStepCompleted(step),
            disabled: isStepDisabled(step),
            'validation-error': hasStepValidationError(step)
          }"
          (click)="goToStep(i)"
          [class.clickable]="!isStepDisabled(step) || allowSkipSteps"
        >
          <div class="step-title-container">
            <!-- Step Number/Circle -->
            <div class="step-circle">
              <span *ngIf="showStepNumbers && !isStepCompleted(step)" class="step-number"> {{ i + 1 }}</span>
              <i *ngIf="isStepCompleted(step) && !(hasStepValidationError(step) && showValidationErrors)"
                class="fas fa-check step-check-icon"></i>
              <i *ngIf="hasStepValidationError(step) && showValidationErrors" class="fas fa-exclamation step-error-icon"></i>
            </div>

            <!-- Step Title -->
            <div class="step-title">
              {{ step.title }}
            </div>
          </div>
          <!-- Error Message for Completed Steps -->
          <!-- <div class="d-none">
            step - {{ step.title }} <br />
            isStep - {{ isStepCompleted(step) ? 'true' : 'false' }} <br />
            hasStepValidationError - {{ hasStepValidationError(step) ? 'true' : 'false' }} <br />
            showValidationErrors - {{ showValidationErrors ? 'true' : 'false' }} <br />
          </div> -->
          <!-- <div *ngIf="isStepCompleted(step) && hasStepValidationError(step) && showValidationErrors" class="step-error-message">
            <div class="error-content">
              <div class="error-text">⚠️ {{ step.errorMessage || 'Validation errors found' }}</div>
              <div *ngIf="step.errorDetails && step.errorDetails.length > 0" class="error-details">
                <div *ngFor="let detail of step.errorDetails" class="error-detail">• {{ detail }}</div>
              </div>
            </div>
          </div> -->
        </div>
      </ng-container>
    </div>

    <ng-container *ngFor="let step of steps; let i = index">
      <div class="row">
        <!-- Error Message for Completed Steps -->
        <div class="d-none">
          step - {{ step.title }} <br />
          isStep - {{ isStepCompleted(step) ? 'true' : 'false' }} <br />
          hasStepValidationError - {{ hasStepValidationError(step) ? 'true' : 'false' }} <br />
          showValidationErrors - {{ showValidationErrors ? 'true' : 'false' }} <br />
        </div>
        <div
          *ngIf="isStepCompleted(step) && hasStepValidationError(step) && showValidationErrors"
          class="step-error-message col-12 col-md-auto"
        >
          <div class="error-content">
            <div class="error-text">⚠️ {{ step.errorMessage || 'Validation errors found' }}</div>
            <div *ngIf="step.errorDetails && step.errorDetails.length > 0" class="error-details align-items-center d-flex">
              <ng-container *ngFor="let detail of step.errorDetails"> • {{ detail }}</ng-container>
              <!-- <span *ngFor="let detail of step.errorDetails" ></span> -->
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Progress Bar -->
    <div class="progress-bar-container mt-2">
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="(currentStepIndex / (steps.length - 1)) * 100"></div>
      </div>
    </div>
  </div>
</div>
